<template>
    <card>
        <template slot="header">
            <h3 class="card-title">User Roles</h3>
        </template>
        <div class="row">
           <div class="col-md-6"> 
            <nav class="row">
               <ol class="breadcrumb arr-right bg-breadcrum">
                  <li class="breadcrumb-item">
                     <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Roles</li>
               </ol>
            </nav>
           </div>
           <!-- <div class="col-md-6">
                <router-link :to="'createroles'" class="btn btn-primary float-right"><i class="fa fa-plus"></i> &nbsp;Create Roles</router-link>
             </div>  -->
         </div>
         <hr style="margin-top:-10px"/>
           <div class="table-responsive ">
                <table class="table table-striped" v-loading="loading">
                        <tbody>
                             <tr v-for="item in items">
                                 <td><a href="#" @click="get_selected_id(item)" v-b-modal.update-roles  class="link-default-user-roles"  v-b-tooltip.hover title="Update Roles"><u>{{item.roles_name}}</u></a> <br/> <i>{{item.description}}</i><br/></td>
                            </tr>
                        </tbody>
                </table>
            </div>
         <!-- MODAL FOR UPDATE RECORD  -->
              <b-modal id="update-roles" ref="hide-roles-update"  size="l"   title="Update Item"  hide-footer>
                <h3>Roles</h3>
                <div class="form-group">
                   <label>Roles Name:</label>
                   <input type="text" class="form-control" v-model="selected_item.roles_name">
                   <label>Description:</label>
                  <textarea class="form-control" rows="6" v-model="selected_item.description"></textarea>
                </div>
                <div class="form-group">
                    <button class="btn btn-info float-right" @click="update_roles"><i class="fa fa-save"></i>&nbsp;Save Changes</button>
                </div>
             </b-modal>
    </card>		
    </template>
    <script>
    /* eslint-disable */
    import Card from 'src/components/UIComponents/Cards/Card.vue'
    export default {
       components: {
           Card
       },
       data(){
            return{
                items:[],
                selected_item:'',
               //Indicator
                loading: true
            }
        },
    
        mounted: function() {
          this.get_roles()
        
       },
    
        methods:{
           
              get_roles(){
                axios.get('api/userroles')
                    .then(response => {   this.items = response.data;this.loading = false; })  
                    .catch(error => { console.log(error) });
              },
              get_selected_id(item) {
                 this.selected_item = item;
              },
              

             update_roles() {
                    axios.post('api/userroles/update/' + this.selected_item.id, {
                           roles_name: this.selected_item.roles_name,
                           description: this.selected_item.description
                        })
                        .then(resp => {
                            if(resp.data.response == 'noupdate'){
                                    console.log(resp.data.message);
                                    this.$swal('Error', resp.data.message ,'error')
                            }else if(resp.data.response == 'success'){
                                   console.log(resp.data.message);
                                     this.$swal('Success', resp.data.message ,'success')
                                     this.$router.push({name: 'users-roles'}) 

                                     this.roles_name = ''
                                     this.get_roles();
                                     this.$refs['hide-roles-update'].hide();
                                     console.log(response.data)
                                
                            }      
                        })
                        .catch(e => { console.log(e) })
                }

       },
      
    }
    </script>
    <style>
         .bg-breadcrum{
                background:#fff;
             }

            .link-default-user-roles{
                color: #666;
             }
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-user-roles/todo-user-roles.vue